/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createBadgeSubmission = /* GraphQL */ `
  mutation CreateBadgeSubmission(
    $input: CreateBadgeSubmissionInput!
    $condition: ModelBadgeSubmissionConditionInput
  ) {
    createBadgeSubmission(input: $input, condition: $condition) {
      id
      email
      siteCode
      formType
      tokenNumber
      queuePosition
      estimatedTime
      timeSlot
      slotPosition
      photoTaken
      status
      updatedBy
      submissionDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBadgeSubmission = /* GraphQL */ `
  mutation UpdateBadgeSubmission(
    $input: UpdateBadgeSubmissionInput!
    $condition: ModelBadgeSubmissionConditionInput
  ) {
    updateBadgeSubmission(input: $input, condition: $condition) {
      id
      email
      siteCode
      formType
      tokenNumber
      queuePosition
      estimatedTime
      timeSlot
      slotPosition
      photoTaken
      status
      updatedBy
      submissionDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBadgeSubmission = /* GraphQL */ `
  mutation DeleteBadgeSubmission(
    $input: DeleteBadgeSubmissionInput!
    $condition: ModelBadgeSubmissionConditionInput
  ) {
    deleteBadgeSubmission(input: $input, condition: $condition) {
      id
      email
      siteCode
      formType
      tokenNumber
      queuePosition
      estimatedTime
      timeSlot
      slotPosition
      photoTaken
      status
      updatedBy
      submissionDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
